import React from 'react';
import config from '../../../config';
import { getSpaceId } from '../../../Utils/authentication-access';
import { ShareJoinSpaceLinkContent } from './component';

export const ShareJoinSpaceLinkContentContainer = ({ spaceId }) => {
  spaceId = spaceId || getSpaceId();
  const link = `${config.APP_URL}/join/spaces/${spaceId}`;
  const headingText = 'Invite anyone to join your Team';

  return <ShareJoinSpaceLinkContent link={link} headingText={headingText} />;
};
